import React from "react";

export default function ReviewSlide({ rating, slide, next, previous, children }) {
  return (
    <div id={"slide" + slide} class="carousel-item w-full">
      <div className="max-w-[992px] mx-auto relative">
        <div className="flex flex-col items-center px-24 py-8">
          <div class="rating rating-lg">
            {Array.from({
              length: parseInt(rating),
            }).map(() => (
              <input
                type="radio"
                name="rating-8"
                class="mask mask-star-2 bg-green-500"
                checked
              />
            ))}

            {Array.from({
              length: 5 - parseInt(rating),
            }).map(() => (
              <input
                type="radio"
                name="rating-8"
                class="mask mask-star-2 bg-gray-500"
                checked
              />
            ))}
          </div>

          {children}
        </div>

        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a
            href={"#slide" + (previous)}
            class="btn btn-circle hover:no-underline"
          >
            ❮
          </a>

          <a
            href={"#slide" + (next)}
            class="btn btn-circle hover:no-underline"
          >
            ❯
          </a>
        </div>
      </div>
    </div>
  );
}
